export default "__VITE_ASSET__CE9hn472__"